var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.59 3.18001H3.5L5.15 1.53001C5.29294 1.39072 5.37357 1.1996 5.37357 1.00001C5.37357 0.800424 5.29294 0.609299 5.15 0.470011C4.85718 0.177558 4.38281 0.177558 4.09 0.470011L1.16 3.40001C1.09221 3.46937 1.03795 3.55076 0.999997 3.64001C0.930014 3.82357 0.930014 4.02646 0.999997 4.21001C1.03539 4.30355 1.08988 4.3887 1.16 4.46001L4.09 7.39001C4.23284 7.52718 4.422 7.6057 4.62 7.61001C4.81841 7.60771 5.00828 7.5289 5.15 7.39001C5.29294 7.25072 5.37357 7.0596 5.37357 6.86001C5.37357 6.66042 5.29294 6.4693 5.15 6.33001L3.5 4.68001H10.59C12.6335 4.68001 14.29 6.33656 14.29 8.38001V10.55C14.3019 12.5442 12.7232 14.185 10.73 14.25H2.83C2.41578 14.25 2.08 14.5858 2.08 15C2.08 15.4142 2.41578 15.75 2.83 15.75H10.76C13.5604 15.6579 15.7778 13.3519 15.76 10.55V8.38001C15.76 5.51981 13.4502 3.19651 10.59 3.18001Z",
    fill: "#8b909a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutArrow);
export default __webpack_public_path__ + "static/media/logout_arrow.1ea4520af7c781a6832db8c9c4a1fec3.svg";
export { ForwardRef as ReactComponent };